import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-yonghuming",
  "use": "icon-yonghuming-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-yonghuming\"><path d=\"M502.272 56.896c128.704 0 233.088 101.888 233.088 227.52C735.36 410.112 631.04 512 502.272 512S269.184 410.112 269.184 284.416 373.568 56.96 502.272 56.96z m0 0c128.704 0 233.088 101.888 233.088 227.52C735.36 410.112 631.04 512 502.272 512S269.184 410.112 269.184 284.416 373.568 56.96 502.272 56.96zM414.848 587.84h194.304c166.272 0 301.056 131.584 301.056 293.952v18.88c0 64-134.784 66.432-301.056 66.432H414.848c-166.272 0-301.056-0.064-301.056-66.432v-18.88c0-162.368 134.784-293.952 301.056-293.952z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yonghuming.svg
// module id = vXUM
// module chunks = 12